/* ==========================================================================
   HAPŪ HELPERS — HEADER MOBILE BEHAVIOR
   --------------------------------------------------------------------------
   Companion to hapu-header-footer.css.
   
   When the user taps outside the drawer (the dimmed area above it),
   we trigger Dawn's normal close mechanism by programmatically
   clicking the hamburger summary. This is much better than directly
   manipulating attributes because Dawn's MenuDrawer class handles the
   full close routine (remove .menu-opening class → wait for animation
   → remove [open] attribute → restore focus → unlock body scroll).
   
   Only runs below 990px — the bottom sheet pattern only applies there.
   ========================================================================== */

(function () {
  'use strict';

  function closeDrawer(container) {
    if (!container || !container.hasAttribute('open')) return;
    var summary = container.querySelector('summary');
    if (summary) summary.click();
  }

  /* Click anywhere outside the drawer panel → close via Dawn's mechanism */
  document.addEventListener('click', function (e) {
    if (window.innerWidth >= 990) return;

    var container = document.querySelector('.menu-drawer-container[open]');
    if (!container) return;

    var panel = container.querySelector('.menu-drawer');
    var summary = container.querySelector('summary');

    // Click was inside the drawer panel? Ignore.
    if (panel && panel.contains(e.target)) return;

    // Click was on the hamburger summary? Let Dawn handle it.
    if (summary && summary.contains(e.target)) return;

    // Otherwise — click was outside, on the backdrop area. Close.
    closeDrawer(container);
  });

  /* Escape key → close (Dawn already handles this, but harmless redundancy) */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (window.innerWidth >= 990) return;
    closeDrawer(document.querySelector('.menu-drawer-container[open]'));
  });
})();